import { SearchBtnCard } from '@playbooks/molecules/cards';

export const SearchPreviewCard = ({ icon = 'magnifying-glass', hit, modelName = '', onClick, className = '' }) => {
	return (
		<SearchBtnCard
			icon={icon}
			title={hit.title || hit.name || hit.query}
			text={hit.tagline || hit.description}
			index={modelName || hit.index}
			onClick={() => onClick(hit)}
			className={className}
		/>
	);
};
export const SearchSearchCard = ({ hit, onClick, className = '' }) => {
	// Render
	return (
		<SearchBtnCard
			icon='magnifying-glass'
			index={hit.index}
			photo={hit.thumbnail}
			title={hit.title || hit.name || hit.query}
			text={hit.tagline || hit.description}
			onClick={() => onClick(hit)}
			className={className}
		/>
	);
};
